<div class="container layout-vbox" style="height: 100%">
    <div class="layout-hbox" style="overflow: hidden; height: 100%; max-width: 100%;">
        <wj-tab-panel #tabPanel class="tabs-left" (selectedTabChange)="onSelectedTabChange($event)" [selectedIndex]="4">
            <wj-tab>
                <a [innerHTML]="tabLabel('Sheets', 'fa-file')"></a>
                <div>
                    <app-worksheets-list></app-worksheets-list>
                </div>
            </wj-tab>
            <wj-tab>
                <a [innerHTML]="tabLabel('Ranges', 'fa-list')"></a>
                <div>
                    <app-ranges-list></app-ranges-list>
                </div>
            </wj-tab>
            <wj-tab>
                <a [innerHTML]="tabLabel('Tables', 'fa-table')"></a>
                <div>
                    <app-tables-list></app-tables-list>
                </div>
            </wj-tab>
            <wj-tab>
                <a [innerHTML]="tabLabel('XML', 'fa-code')"></a>
                <div>
                    <app-custom-xml-list></app-custom-xml-list>
                </div>
            </wj-tab>
            <wj-tab>
                <a [innerHTML]="tabLabel('MCP', 'fa-plug')"></a>
                <div>
                    <app-mcp-connector></app-mcp-connector>
                </div>
            </wj-tab>
            <wj-tab>
                <a [innerHTML]="tabLabel('Chat', 'fa-stars')"></a>
                <div>
                    <div style="height: 100%; overflow: hidden auto">
                        <app-ai-chat></app-ai-chat>
                    </div>
                </div>
            </wj-tab>
        </wj-tab-panel>
    </div>
    <div class="status layout-hbox">
        Status as of {{now()}} &cdot;
        <div (click)="toggleCompactMode()" title="Toggle Compact Mode" style="cursor:pointer;">
            <i class="far fa-toggle-{{compactMode() ? 'off' : 'on'}}"></i>
        </div>
    </div>
</div>
